import { createSlice } from '@reduxjs/toolkit';

import {
  PMTaskDefinitionState,
  PMTaskDefinitionFetchAction,
  PMTaskDefinitionFetchSuccessAction,
  PMTaskDefinitionDeleteAction,
  PMTaskDefinitionUpdateSuccess,
  PMTaskDefinitionCreateAction,
  PMTaskDefinitionUpdateAction,
} from './PMTaskDefinition.type';
import { createSliceHook, makeActionCreator } from '../helpers';

const { act, actReject, actReq, actResolve } =
  makeActionCreator<PMTaskDefinitionState>();

const initialState: PMTaskDefinitionState = {
  data: [],
  loading: false,
};

export const pmTaskDefinitionSlice = createSlice({
  name: 'pmTaskDefinition',
  initialState,
  reducers: {
    fetchPMTaskDefinitions: actReq<PMTaskDefinitionFetchAction['payload']>(),
    fetchPMTaskDefinitionsSuccess:
      actResolve<PMTaskDefinitionFetchSuccessAction['payload']>(),
    fetchPMTaskDefinitionsFailure: actReject<Error>(),

    createPMTaskDefinition: actReq<PMTaskDefinitionCreateAction['payload']>(),
    createPMTaskDefinitionSuccess: actResolve(),
    createPMTaskDefinitionFailure: actReject<Error>(),

    updatePMTaskDefinition: actReq<PMTaskDefinitionUpdateAction['payload']>(),
    updatePMTaskDefinitionSuccess: act<
      PMTaskDefinitionUpdateSuccess['payload']
    >((data, state) => {
      const updateStateData = state.data.map(definitionTask =>
        definitionTask.id !== data?.id ? definitionTask : data
      );
      return { ...state, data: updateStateData, loading: false };
    }),
    updatePMTaskDefinitionFailure: actReject<Error>(),

    deletePMTaskDefinition: actReq<PMTaskDefinitionDeleteAction['payload']>(),
    deletePMTaskDefinitionsSuccess: actResolve(),
    deletePMTaskDefinitionsFailure: actReject<Error>(),
  },
});

export const {
  fetchPMTaskDefinitions,
  fetchPMTaskDefinitionsSuccess,
  fetchPMTaskDefinitionsFailure,
  updatePMTaskDefinition,
  updatePMTaskDefinitionSuccess,
  updatePMTaskDefinitionFailure,
} = pmTaskDefinitionSlice.actions;

export const actions = { ...pmTaskDefinitionSlice.actions };

export const usePMTaskDefinitionSlice = createSliceHook(
  pmTaskDefinitionSlice.name,
  actions
);
